/* This file is also inlined before redirects by HtmlWebpackPlugin. Keep it ES5. */
;(function (root, factory) {
  var api = root.__metaAttribution || factory(root)
  root.__metaAttribution = api
})(window, function (root) {
  var key = 'meta.click.v1'
  var lifetime = 90 * 24 * 60 * 60 * 1000
  var memory = null
  var cookieDomain

  function decode (value) {
    try { return decodeURIComponent(value.replace(/\+/g, ' ')) } catch (e) { return value }
  }
  function query (text) {
    return text.replace(/^\?/, '').split('&').filter(function (part) { return !!part })
  }
  function name (part) { return decode(part.split('=')[0]) }
  function value (parts, field) {
    for (var i = 0; i < parts.length; i++) {
      if (name(parts[i]) === field) {
        var at = parts[i].indexOf('=')
        return at < 0 ? '' : decode(parts[i].slice(at + 1))
      }
    }
    return ''
  }
  function incoming () {
    var hash = root.location.hash || ''
    var index = hash.indexOf('?')
    return query(root.location.search || '').concat(index < 0 ? [] : query(hash.slice(index + 1)))
  }
  function valid (record) {
    return record && typeof record.id === 'string' && /^[A-Za-z0-9_-]+$/.test(record.id) &&
      record.id.length <= 2048 && typeof record.time === 'number' && record.time <= Date.now() &&
      record.time > Date.now() - lifetime
  }
  function cookieRecord () {
    var cookies = ''
    try { cookies = root.document.cookie } catch (e) {}
    var match = cookies.match(/(?:^|;\s*)_fbc=([^;]+)/)
    if (!match) return null
    var parts = decode(match[1]).split('.')
    if (parts.length !== 4 || parts[0] !== 'fb' || !/^\d+$/.test(parts[1])) return null
    var record = { id: parts[3], time: Number(parts[2]), index: parts[1] }
    return valid(record) ? record : null
  }
  function domain () {
    if (cookieDomain !== undefined) return cookieDomain
    cookieDomain = ''
    var host = root.location.hostname
    if (!host || /^[\d.]+$/.test(host) || host.indexOf(':') !== -1) return cookieDomain
    var labels = host.split('.')
    // Browsers reject public suffixes. Probe instead of assuming the last two labels
    // are a registrable domain (which fails for hosts such as www.example.co.in).
    var token = String(Date.now()) + String(Math.random()).slice(2)
    for (var i = labels.length - 2; i >= 0; i--) {
      var candidate = labels.slice(i).join('.')
      root.document.cookie = '_meta_domain_probe=' + token + ';domain=' + candidate + ';path=/;max-age=1'
      if (root.document.cookie.indexOf('_meta_domain_probe=' + token) !== -1) {
        root.document.cookie = '_meta_domain_probe=;domain=' + candidate + ';path=/;max-age=0'
        cookieDomain = ';domain=' + candidate
        break
      }
    }
    return cookieDomain
  }
  function restore () {
    var record = cookieRecord()
    if (valid(memory) && (!record || memory.time >= record.time)) record = memory
    var saved = null
    try { saved = JSON.parse(root.localStorage.getItem(key)) } catch (e) {}
    if (valid(saved) && (!record || saved.time > record.time)) record = saved
    var id = value(incoming(), 'fbclid')
    if (id && (!record || record.id !== id)) {
      var next = { id: id, time: Date.now() }
      if (valid(next)) record = next
    }
    if (!valid(record)) {
      try { root.localStorage.removeItem(key) } catch (e) {}
      return null
    }
    memory = record
    try { root.localStorage.setItem(key, JSON.stringify(record)) } catch (e) {}
    // Keep the original capture time and expiry; never renew an old click on each visit.
    var fbc = 'fb.' + (record.index || '1') + '.' + record.time + '.' + record.id
    try {
      var scope = domain()
      // Avoid a host-only copy shadowing the shared www/m cookie.
      if (scope) root.document.cookie = '_fbc=;path=/;max-age=0'
      root.document.cookie = '_fbc=' + encodeURIComponent(fbc) + scope + ';path=/;max-age=' +
        Math.max(1, Math.floor((record.time + lifetime - Date.now()) / 1000)) + ';SameSite=Lax' +
        (root.location.protocol === 'https:' ? ';Secure' : '')
    } catch (e) {}
    return record
  }
  function redirectUrl (target, removeAgent) {
    var link = root.document.createElement('a')
    link.href = target
    var parts = query(link.search || '')
    incoming().forEach(function (part) {
      var field = name(part)
      if (!parts.some(function (current) { return name(current) === field })) parts.push(part)
    })
    if (removeAgent) {
      parts = parts.filter(function (part) {
        return name(part) !== 'agentCode' && name(part) !== 'inviteCode'
      })
    }
    link.search = parts.length ? '?' + parts.join('&') : ''
    return link.href
  }
  try { restore() } catch (e) { /* Storage restrictions must not block the application. */ }
  return { restore: restore, redirectUrl: redirectUrl }
})



// WEBPACK FOOTER //
// ./src/common/utils/metaAttribution.js